module.exports = __webpack_public_path__ + "f3b9f4460fd12e125644b1bbacffa720.svg";